export enum ListType {
  BULLET = 'bullet',
  NUMBER = 'number',
  CHECKBOX_CHECKED = 'checkbox-checked',
  CHECKBOX_UNCHECKED = 'checkbox-unchecked',
}

export const INDENT_SIZE = 35;

export const MAX_INDENTATION = 5;
